import { render, staticRenderFns } from "./OrganHeart.vue?vue&type=template&id=079b3b23&scoped=true&"
var script = {}
import style0 from "./OrganHeart.vue?vue&type=style&index=0&id=079b3b23&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079b3b23",
  null
  
)

export default component.exports